import { atom } from "jotai";

export const userNameAtom = atom("");
export const userTitleAtom = atom("");
export const isPreviewAtom = atom(false);
